import React from 'react';

const FooterComponent = () => {
  return (
    <div className="bg-white px-4 py-3 text-left text-sm text-gray-500 border-t">
      <p>Leadgenflow</p>
    </div>
  );
};

export default FooterComponent;
